"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalOpsState = void 0;
const HashedObject_1 = require("../../../data/model/HashedObject");
const HashedSet_1 = require("../../../data/model/HashedSet");
class TerminalOpsState extends HashedObject_1.HashedObject {
    constructor(objectHash, terminalOps) {
        super();
        this.objectHash = objectHash;
        if (terminalOps !== undefined) {
            this.terminalOps = new HashedSet_1.HashedSet(new Set(terminalOps).values());
        }
    }
    static create(objectHash, terminalOps) {
        return new TerminalOpsState(objectHash, terminalOps);
    }
    getClassName() {
        return TerminalOpsState.className;
    }
    async validate(references) {
        references;
        return this.objectHash !== undefined && this.terminalOps !== undefined;
    }
    init() {
    }
}
exports.TerminalOpsState = TerminalOpsState;
TerminalOpsState.className = 'hhs/v0/TerminalOpsState';
TerminalOpsState.registerClass(TerminalOpsState.className, TerminalOpsState);
//# sourceMappingURL=TerminalOpsState.js.map